import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';
import { Contact } from '../types/Contact';
import { AvailableTimeSlot } from '../types/DynamicsService';
import Availability from './Availability';
import Col100 from './Col100';
import Header from './Header';
import Processing from './Processing';
type Props = {
  onComplete: ((timeSlot: AvailableTimeSlot) => void);
  client: Contact;
}
export default function DateAndTime(props: Props): JSX.Element {
  const { onComplete, client } = props;
  // Local state
  const tomorrow = DateTime.fromObject({ hour: 0, minute: 0, second: 0 }).plus({ days: 2 });
  const [moreDates, setMoreDates] = useState(false);
  const [otherDate, setOtherDate] = useState<DateTime>();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<AvailableTimeSlot>();
  const [inputs, setInputs] = useState({
    assessmentDate: tomorrow.plus({ days: 2 }).toISODate(),
  });
  const tomorrowOffset = tomorrow.weekday < 6 ? 0 : 8 - tomorrow.weekday;

  // Accessors
  const { assessmentDate } = inputs;

  // Event Handlers
  function clearTimeSlot() {
    setInputs((inputs) => ({ ...inputs, selectedTimeSlot: "" }));
  }
  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
    const { name, value } = e.target;
    // setIsDirty(true);
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  }
  function handleAssessmentDate() {
    clearTimeSlot();
    setOtherDate(DateTime.fromISO(assessmentDate));
  }
  function handleMoreDates(e: React.MouseEvent) {
    setMoreDates(true);
    clearTimeSlot();
  }
  function handleSelectTimeslot(timeSlot: AvailableTimeSlot) {
    setSelectedTimeSlot(timeSlot);
  }

  function handleSubmit(e: React.FormEvent) {
    console.log("handleSubmit", e);
    e.preventDefault();
    setSubmitting(true);

    if (!selectedTimeSlot) {
      // TODO Validation
      return;
    }

    // Advance to Step 4 by calling the onComplete callback handler in App
    // onComplete(sameAsPrevious, contact);
    onComplete(selectedTimeSlot);
  }

  const timeoutRef = React.useRef<number>();
  useEffect(
    () => {
      // fetch availability
      timeoutRef.current = window.setTimeout(
        () => handleAssessmentDate(),
        500
      );
      return () => clearTimeout(timeoutRef.current);
    },
    [assessmentDate, handleAssessmentDate]
  );

  if (submitting) {
    return (<Col100><Processing /></Col100>);
  }
  return <Col100>
      <Header>Select Your Date and Time</Header>
      <div className="elementor-element elementor-widget elementor-widget-text-editor" data-element_type="widget" data-widget_type="text-editor.default">
        <div className="elementor-widget-container">
          <div className="elementor-text-editor elementor-clearfix">
            <p>
              A SafeHaven RN Guide will conduct a comprehensive virtual first visit at the date and time you select below. Most initial appointments take approximately 45 minutes to complete and are a personalized review of {client.firstName}'s social supports, safety, security, and home maintenance needs.
            </p>
          </div>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="order-form elementor-form" id="orderForm" name="OrderForm">
        <div className="elementor-form-fields-wrapper elementor-labels elementor-column-gap-default">
          {moreDates && <div className="elementor-row">
              <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-5f6353a" data-id="5f6353a" data-element_type="column">
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap">
                    <div className="mt-2 elementor-element elementor-element-6629568 elementor-widget elementor-widget-heading" data-id="6629568" data-element_type="widget" data-widget_type="heading.default">
                      <div className="elementor-widget-container">
                        <h5 className="elementor-heading-title elementor-size-default">
                          Check Availability
                        </h5>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-3d71735 elementor-widget elementor-widget-text-editor" data-id="3d71735" data-element_type="widget" data-widget_type="text-editor.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-text-editor elementor-clearfix">
                          <p>
                            Select the date you'd like to schedule your visit below, and we'll let you know what time slots are available on that day.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 element-599a7cf" data-id="599a7cf" data-element_type="widget" data-widget_type="html.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-form-fields-wrapper elementor-labels-">
                          <div className="elementor-field-type-date elementor-field-group elementor-column elementor-field-group-field_dob">
                            <div className="elementor-row d-flex align-items-center">
                              {/* <div className="flex-grow-1">
                                <label htmlFor="assessmentDate" className="elementor-field-label pr-1">
                                  Choose a date:
                                </label>
                              </div> */}
                              <div>
                                <input type="date" name="assessmentDate" id="assessmentDate" className="input da-plugin" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" min={tomorrow.toISODate()} onChange={handleChange} value={assessmentDate} />{" "}
                              </div>
                              <button type="button" className="et_pb_button et_pb_button_0 et_pb_bg_layout_light ml-1" onClick={handleAssessmentDate}>
                                <span className="elementor-button-text mr-1">
                                  Go
                                </span>
                                <i aria-hidden="true" className="fas fa-refresh" />{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {otherDate && <div className="elementor-row">
                        <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element" data-element_type="column">
                          <div className="elementor-column-wrap elementor-element-populated">
                            <Availability date={otherDate} onSelectTimeslot={handleSelectTimeslot} selectedTimeSlot={selectedTimeSlot} />
                          </div>
                        </div>
                      </div>}
                  </div>
                </div>
              </div>
            </div>}
          {!moreDates && <div className="d-flex mt-2">
              <div className="flex-fill" data-id="d36acd2" data-element_type="column">
                <div className="elementor-column-wrap elementor-element-populated">
                  <Availability date={tomorrow.plus({
                      days: tomorrowOffset
                    })} onSelectTimeslot={handleSelectTimeslot} selectedTimeSlot={selectedTimeSlot} />
                </div>
              </div>
              <div className="flex-fill" data-id="9e6df35" data-element_type="column">
                <div className="elementor-column-wrap elementor-element-populated">
                  <Availability date={tomorrow.plus({
                      days: tomorrowOffset + 1
                    })} onSelectTimeslot={handleSelectTimeslot} selectedTimeSlot={selectedTimeSlot} />
                </div>
              </div>
              <div className="flex-fill" data-id="1012685" data-element_type="column">
                <div className="elementor-column-wrap elementor-element-populated">
                  <button className="et_pb_button et_pb_button_0 et_pb_bg_layout_light flex-grow-1" onClick={handleMoreDates}>
                    <i aria-hidden="true" className="fas fa-calendar-alt" /> More Dates
                  </button>
                </div>
              </div>
            </div>}
          <div className="d-flex pt-1">
            {!selectedTimeSlot && <button type="button" disabled={true} className="et_pb_button et_pb_button_0 et_pb_bg_layout_light flex-grow-1 disabled">
                <span className="elementor-button-text mr-1">Next</span>
                <i aria-hidden="true" className="fas fa-angle-right" />{" "}
              </button>}
            {selectedTimeSlot && <button type="submit" className="et_pb_button et_pb_button_0 et_pb_bg_layout_light flex-grow-1">
                <span className="elementor-button-text mr-1">
                  Schedule Virtual Visit
                </span>
                <i aria-hidden="true" className="fas fa-angle-right" />
              </button>}
          </div>
        </div>
      </form>
    </Col100>;
}